import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import AboutSection from './components/AboutSection';
import Nav from './components/Nav';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPage';
import TermsOfService from './components/TermsOfService';
import ScrollToTop from './components/ScrollToTop';
import ContactPage from './components/ContactPage';
import PricingPage from './components/PricingPage';
import FAQPage from './components/FAQPage';
import OurPartners from './components/OurPartners';

function App() {
  return (
    <Router>
      <div>
        <Nav />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutSection />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/faqs" element={<FAQPage />} />
          <Route path="/partners" element={<OurPartners />} />
        </Routes>
        <Footer/>
      </div>
    </Router>
  );
}

export default App;